/** Punto de entrada de la consola de operador (docs/FASE-1.md §6). */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./styles.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("No se encontró el contenedor #root de la consola.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
